import { ZonedDateTime } from '@js-joda/core';
import { ResourceConfig } from '@hidat/huijs-resource';
import { AnyHash, Uuid } from '@hidat/huijs-common';

export const AppSessionConfig: ResourceConfig = new ResourceConfig(
  'AppSession',
  'app_sessions',
  true,
  false,
);

export interface AppSessionInterface {
  id: Uuid | undefined;

  sessionId: Uuid | undefined;
  appCode: string | undefined;
  authenticationToken: string | undefined;
  appToken: string | undefined;
  expiresAt: ZonedDateTime | undefined;

  tenantId: Uuid | undefined;
  userId: Uuid | undefined;

  createdAt?: ZonedDateTime;
  updatedAt?: ZonedDateTime;
  roles: AnyHash | undefined;
  permissions: AnyHash | undefined;
}
